/**
 * Layout: Checkout
 * -----------------------------------------------------------------------------
 * Entry file for all checkout scripts.
 *
 */
import '../../styles/checkout.scss';
import checkoutCount from '../components/checkout-cart-count';
import loqateValidator from '../components/checkout-loqate-snippet';
import {on, handleize} from '../helpers/utils';
import greekValidation from '../components/checkout-greek-validation';
import checkoutAddOn from '../components/checkout-add-on';
import FreeGift from '../components/free-gift';
import engravingLineItems from '~/components/engraving-line-items';
import EventBus from '~/helpers/event-bus';
import DataLayer from '~/helpers/datalayers';

let loaded = false;

/**
 * Global Frame utils.
 */
window.Frame = window.Frame || {};
window.Frame.EventBus = EventBus();

['DOMContentLoaded', 'page:load', 'page:change', 'page:update'].forEach((event) => {
  document.addEventListener(event, () => {
    // Load these functions once.
    if (!loaded) {
      DataLayer().init();
      checkoutCount().init();
      loqateValidator().init();

      if (theme.engraving.allow) {
        engravingLineItems().validateCheckoutCart();
      }
    }

    if (theme.features.freeGift) {
      FreeGift().validateCheckoutCart();
    }

    greekValidation().init();
    checkoutAddOn().init();

    loaded = true;
  });
});

document.addEventListener('page:load', () => {
  switch (Shopify.Checkout.step) {
    case 'contact_information':
      // eslint-disable-next-line no-case-declarations
      const timerContacts = window.setInterval(() => {
        if (!window.dataLayer) {
          return;
        }

        clearInterval(timerContacts);
        window.dataLayer.push({
          event: 'checkout',
          ecommerce: {
            currencyCode: window.theme.strings.currency,
            checkout: {
              actionField: {step: 1},
              products: window.products_checkout,
            },
          },
        });
      }, 100);
      break;

    case 'shipping_method':
      // eslint-disable-next-line no-case-declarations
      const timerShipping = window.setInterval(() => {
        if (!window.dataLayer) {
          return;
        }

        clearInterval(timerShipping);
        window.dataLayer.push({
          event: 'checkout',
          ecommerce: {
            currencyCode: window.theme.strings.currency,
            checkout: {
              actionField: {
                step: 2,
                option: window.userLogged,
              },
              products: window.products_checkout,
            },
          },
        });
      }, 100);
      break;

    case 'payment_method':
      on('click', document.querySelector('#continue_button'), () => {
        const paymentMethods = document.querySelector('[data-payment-method]');
        const selectedMethod = paymentMethods.querySelector('input:checked');
        const methodName = handleize(selectedMethod.closest('.radio-wrapper').querySelector('.radio__label__primary').innerHTML.trim()).replace(/-/g, '_');


        window.dataLayer.push({
          event: 'checkout',
          ecommerce: {
            currencyCode: window.theme.strings.currency,
            checkout: {
              actionField: {
                step: 4,
                option: methodName,
              },
              products: window.products_checkout,
            },
          },
        });
      });

      // eslint-disable-next-line no-case-declarations
      const timerPayment = window.setInterval(() => {
        if (!window.dataLayer) {
          return;
        }

        clearInterval(timerPayment);
        window.dataLayer.push({
          event: 'checkout',
          ecommerce: {
            currencyCode: window.theme.strings.currency,
            checkout: {
              actionField: {
                step: 3,
                option: window.shippingMethod,
              },
              products: window.products_checkout,
            },
          },
        });
      }, 100);
      break;
  }

  switch (Shopify.Checkout.page) {
    case 'thank_you':
      window.setTimeout(() => {
        const dataLayerObject = window.dataLayerThankYou;
        dataLayerObject.ecommerce.currencyCode = window.theme.strings.currency;
        window.dataLayer.push(dataLayerObject);
      }, 100);
      break;
  }
});
